import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _flatten from "lodash-es/flatten";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { View, Text, Page } from '@react-pdf/renderer';
import { hasPlanTasks } from '@mummssoftware/utils/form-engine/form-engine-utils';
import { Contents } from '@mummssoftware/utils/constants';
import { notesIncluded } from '@mummssoftware/utils/utils';
import { fromDateToDate, ios, pageOrientation, pageSize, safari, styles } from '../../utils';
import { CPPListingPDF } from './components/CPPListingPDF';
import { CPPContentsPDF } from './components/CPPContentsPDF';
import { CPPNotesPDF } from './components/CPPNotesPDF';
import { matchTaskWithPlan, filterTaskWithPlan } from './utils';
import { CPPTasksPDF } from './components/CPPTasksPDF';
import { PrintHeaderPDFComponent } from '../Header';
import { PrintFooterPDFComponent } from '../Footer';
import defaults from '../../translations/en.json';

const NoCarePlanProblemsComponent = ({
  dashboardPrintConfig,
  pdfCarePlanProblems
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.textAlignCenter]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.CPFTableDetailsText
}, pdfCarePlanProblems && pdfCarePlanProblems.length === 0 && dashboardPrintConfig && dashboardPrintConfig.fromDate && dashboardPrintConfig.toDate ? defaults.noCPPInEffectDuringDateRange : defaults.noCarePlansToPrint));

var _ref = /*#__PURE__*/React.createElement(View, null);

var _ref2 = /*#__PURE__*/React.createElement(View, null);

var _ref3 = /*#__PURE__*/React.createElement(View, null);

var _ref4 = /*#__PURE__*/React.createElement(PrintFooterPDFComponent, null);

export const CarePlanProblemsPDF = ({
  dashboardPrintConfig,
  cppNotesGlobal,
  pdfCarePlanProblems,
  browser,
  patient
}) => {
  var _shallowDashboardPrin;

  const shallowDashboardPrintConfigView = dashboardPrintConfig && _objectSpread({}, dashboardPrintConfig);

  const isContentView = (shallowDashboardPrintConfigView === null || shallowDashboardPrintConfigView === void 0 ? void 0 : (_shallowDashboardPrin = shallowDashboardPrintConfigView.CarePlanProblems) === null || _shallowDashboardPrin === void 0 ? void 0 : _shallowDashboardPrin.view) === Contents;
  const CPPPrintView = shallowDashboardPrintConfigView === null || shallowDashboardPrintConfigView === void 0 ? void 0 : shallowDashboardPrintConfigView.CarePlanProblems;
  const allCppTasksGen = pdfCarePlanProblems && pdfCarePlanProblems.length ? pdfCarePlanProblems.filter(x => {
    var _x$patientCppTaskDtos;

    return x === null || x === void 0 ? void 0 : (_x$patientCppTaskDtos = x.patientCppTaskDtos) === null || _x$patientCppTaskDtos === void 0 ? void 0 : _x$patientCppTaskDtos.length;
  }).map(x => x.patientCppTaskDtos) : null;
  const allCppTasksFlat = allCppTasksGen && allCppTasksGen.length ? _flatten(allCppTasksGen) : null;
  const allCppTasks = allCppTasksFlat ? allCppTasksFlat.map(task => ({
    [task.patientcareplanproblem_id]: task
  })) : null;
  return /*#__PURE__*/React.createElement(Page, {
    wrap: false,
    size: pageSize,
    orientation: pageOrientation,
    style: browser && browser.name === safari || browser && browser.name === ios ? styles.pageSafari : styles.page
  }, /*#__PURE__*/React.createElement(PrintHeaderPDFComponent, {
    browser: browser,
    patient: patient
  }), /*#__PURE__*/React.createElement(View, {
    style: [styles.textAlignCenter, styles.width100, styles.marginBottomPointFiveCm]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.printerHeaderText]
  }, defaults.carePlanProblems), dashboardPrintConfig && dashboardPrintConfig.fromDate && dashboardPrintConfig.toDate && /*#__PURE__*/React.createElement(Text, {
    style: [styles.fontFamilyItalic, styles.fontSizeTenPt, styles.marginYPointTwoCm]
  }, fromDateToDate(dashboardPrintConfig))), /*#__PURE__*/React.createElement(View, {
    style: styles.width100
  }, pdfCarePlanProblems && pdfCarePlanProblems.length > 0 ? pdfCarePlanProblems.map((plan, index) => {
    const planHasTasks = allCppTasks && hasPlanTasks(plan) && matchTaskWithPlan(allCppTasks, plan.id);
    const pdfTasks = planHasTasks ? filterTaskWithPlan(allCppTasks, plan.id) : null;
    const planTasks = planHasTasks ? allCppTasks : null;
    return /*#__PURE__*/React.createElement(View, {
      key: plan.id,
      break: isContentView && index > 0,
      style: isContentView && styles.paddingBottomTenCm || styles.paddingBottomPointTwoCm
    }, /*#__PURE__*/React.createElement(CPPListingPDF, {
      plan: plan
    }), /*#__PURE__*/React.createElement(Text, {
      style: styles.carePlanProblemHeader
    }, `${plan.careplanproblemname}`), isContentView ? /*#__PURE__*/React.createElement(CPPContentsPDF, {
      formData: plan.formsubmission && plan.formsubmission.replaceAll('\\', ''),
      planTasks: !!planTasks
    }) : _ref, planTasks && isContentView ? /*#__PURE__*/React.createElement(CPPTasksPDF, {
      plan: plan,
      allCppTasks: pdfTasks
    }) : _ref2, notesIncluded(CPPPrintView) && cppNotesGlobal && dashboardPrintConfig ? /*#__PURE__*/React.createElement(CPPNotesPDF, {
      cppNotes: cppNotesGlobal && cppNotesGlobal[plan.id]
    }) : _ref3);
  }) : /*#__PURE__*/React.createElement(NoCarePlanProblemsComponent, {
    dashboardPrintConfig: dashboardPrintConfig,
    pdfCarePlanProblems: pdfCarePlanProblems
  })), _ref4);
};